module.exports = __webpack_public_path__ + "img/solution-tool-system-pic-11.c820492e.png";